export const SELECT_ORGANIZATION = '@superadmin/SELECT_ORGANIZATION';
export const UPDATE_ORGANIZATION = '@superadmin/UPDATE_ORGANIZATION';
